<template>
  <Opdialog
    :title="$t('tianmu.importVideo')"
    :visible.sync="visible"
    class="uploadDailog"
    :is-show-btn="false"
    @onClose="handleClose"
  >
    <div class="uploadDailog_content">
      <video
        v-if="videoUrl"
        ref="videoPlayer"
        controls
        controlsList="nodownload noplaybackrate"
        disablePictureInPicture
        :src="videoUrl"
        class="planImage"
      />

      <div class="video_controls">
        <img :src="require(`@/assets/img/tianmu/${isPlaying ? 'play' : 'pause'}.png`)" @click="togglePlayPause">
        <input
          ref="progressBar"
          type="range"
          :value="(videoCurrentTime / videoDuration) * 100"
          min="0"
          max="100"
          step="0.1"
          class="progress-bar"
          @input="handleProgressChange"
          @mousedown="startSeeking"
          @mouseup="endSeeking"
        >
        <div class="duration">
          <span>{{ formattedCurrentTime }}</span>/
          <span>{{ formattedDuration }}</span>
        </div>
      </div>

      <div class="tips">
        <i class="el-icon-warning yellow" />
        <span>{{ $t('tianmu.upVideoTip') }}</span>
      </div>

      <div class="tips inputDiv">
        <span class="inputTitle">{{ $t('tianmu.customizeName') + '：' }}</span>
        <el-input
          v-model="planName"
          type="text"
          :placeholder="$t('sylogs.plhode3')"
          class="inputPlan"
          maxlength="15"
        />
      </div>

      <div class="addBtn" :class="{ disable: !planName }" @click="handleAdd">
        {{ $t('projectList.add') }}
      </div>
    </div>
  </Opdialog>
</template>

<script>
import Opdialog from '@/components/common/OpDialog.vue'
export default {
  components: {
    Opdialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    videoUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      planName: '',
      lightValue: 100,
      videoDuration: 0,
      videoCurrentTime: 0,
      isSeeking: false,
      isPlaying: false,
    }
  },
  computed: {
    formattedCurrentTime() {
      return this.formatTime(this.videoCurrentTime)
    },
    formattedDuration() {
      return this.formatTime(this.videoDuration)
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.setupVideoControls()
        })
      } else {
        this.removeVideoEventListeners()
      }
    },
  },
  beforeDestroy() {
    this.removeVideoEventListeners()
    const video = this.$refs.videoPlayer
    if (video) video.pause()
  },

  methods: {
    // 公共工具方法
    formatTime(time) {
      const minutes = Math.floor(time / 60)
      const seconds = Math.floor(time % 60)
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
    },

    // 视频控制方法
    setupVideoControls() {
      const video = this.$refs.videoPlayer
      if (!video) return

      video.controls = false
      video.addEventListener('loadedmetadata', this.setVideoDuration)
      video.addEventListener('timeupdate', this.updateVideoProgress)
      video.addEventListener('play', this.setPlayingState)
      video.addEventListener('pause', this.setPausedState)
    },

    removeVideoEventListeners() {
      const video = this.$refs.videoPlayer
      if (video) {
        video.removeEventListener('timeupdate', this.updateVideoProgress)
        video.removeEventListener('loadedmetadata', this.setVideoDuration)
        video.removeEventListener('play', this.setPlayingState)
        video.removeEventListener('pause', this.setPausedState)
      }
    },

    setVideoDuration() {
      const video = this.$refs.videoPlayer
      this.videoDuration = video?.duration || 0
    },

    updateVideoProgress() {
      if (this.isSeeking) return
      const video = this.$refs.videoPlayer
      if (!video) return

      const percent = (video.currentTime / video.duration) * 100
      //this.$refs.progressBar.value = percent
      this.videoCurrentTime = video.currentTime
    },

    setPlayingState() {
      this.isPlaying = true
      this.isPlaying = true
    },

    setPausedState() {
      this.isPlaying = false
      this.isPlaying = false
    },

    togglePlayPause() {
      const video = this.$refs.videoPlayer
      if (!video) return

      if (video.paused || video.ended) {
        video.play().catch(error => {
          console.error('播放失败:', error)
        })
      } else {
        video.pause()
      }
    },

    handleProgressChange(e) {
      if (!this.isSeeking) return
      const video = this.$refs.videoPlayer
      if (!video) return

      const newTime = (e.target.value / 100) * video.duration
      video.currentTime = newTime
      this.videoCurrentTime = newTime
    },

    startSeeking() {
      this.isSeeking = true
      const video = this.$refs.videoPlayer
      if (video && !video.paused) {
        this.isPlaying = true
        video.pause()
      }
    },

    endSeeking() {
      this.isSeeking = false
      const video = this.$refs.videoPlayer
      if (video && this.isPlaying) {
        video.play().catch(error => {
          console.error('恢复播放失败:', error)
        })
      }
    },

    handleClose() {
      this.$emit('close')
      this.planName = ''
    },

    handleAdd() {
      if (!this.planName) return
      this.$emit('add', this.planName, this.lightValue)
      this.planName = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.light {
  width: 380px;
}

.uploadDailog {
  width: 100%;
  height: 100%;

  ::v-deep .el-dialog {
    height: 100%;
    box-sizing: border-box;
    background: #fff;
    overflow: scroll;

    .el-dialog__header {
      background: #2145a4;
      border-radius: 8.53px 8.53px 0px 0px;

      .el-dialog__title {
        color: #ffffff;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #ffffff;
      }
    }
  }
}

.uploadDailog_content {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  box-sizing: border-box;
  flex-direction: column;

  .planImage {
    width: 600px;
    height: 350px;
    object-fit: cover;
  }

  .tips {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 25px;
    flex-direction: row;

    span {
      color: #3d3d3d;
      font-size: 15px;
    }

    .inputTitle {
      text-align: right;
      min-width: 100px;
      color: #333333;
      font-weight: 600;
      font-size: 13px;
      margin-right: 10px;
    }

    .yellow {
      color: rgba(255, 178, 0, 1);
      font-size: 15px;
      margin-right: 3px;
    }

    .inputPlan {
      width: 380px;
    }
  }

  .inputDiv {
    margin-top: 30px;
  }

  .addBtn {
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0px 64px;
    background: #2145a4;
    border-radius: 6px;
    font-size: 19px;
    color: #fff;
    line-height: 40px;
    height: 40px;
    text-align: center;
    cursor: pointer;
    transition: opacity 0.3s;

    &.disable {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }

  .video_controls {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 600px;
    height: 40px;
    background: rgba(0, 0, 0, 0.3);

    img {
      width: 25px;
      height: 25px;
      cursor: pointer;
    }

    .duration {
      color: #fff;
    }

    .progress-bar {
      width: 300px;
      cursor: pointer;
    }
  }
}
</style>
